var React = require('react');

function CellPhone (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M743.86,34.92h-444.39c-36.43,0-66.07,29.64-66.07,66.07v878.02c0,36.43,29.64,66.07,66.07,66.07h444.39c36.43,0,66.07-29.64,66.07-66.07V100.99c0-36.43-29.64-66.07-66.07-66.07ZM761.78,979.01c0,9.88-8.04,17.91-17.91,17.91h-444.39c-9.88,0-17.91-8.04-17.91-17.91V100.99c0-9.88,8.04-17.91,17.91-17.91h124.12c.1,11.31,9.29,20.44,20.62,20.44h154.92c11.33,0,20.52-9.14,20.62-20.44h124.12c9.88,0,17.91,8.04,17.91,17.91v878.02Z","fillRule":"evenodd","key":0}),React.createElement("path",{"d":"M599.13,915.97h-154.92c-11.39,0-20.63,9.24-20.63,20.63s9.24,20.63,20.63,20.63h154.92c11.39,0,20.63-9.24,20.63-20.63s-9.24-20.63-20.63-20.63Z","fillRule":"evenodd","key":1})]);
}

CellPhone.defaultProps = {"id":"ICONS","width":"15in","height":"15in","version":"1.1","viewBox":"0 0 1080 1080"};

module.exports = CellPhone;

CellPhone.default = CellPhone;
